import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../../services/api";
import { AuthContext } from "../Auth/AuthContext";
import { isValidBusinessTimezone } from "../../helpers/dateTimeFormat";

const BusinessTimezoneContext = createContext({
	timeZone: null,
	loading: true,
});

function BusinessTimezoneProvider({ children }) {
	const { user, isAuth } = useContext(AuthContext);
	const [timeZone, setTimeZone] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (!isAuth || !user?.id) {
			setTimeZone(null);
			setLoading(false);
			return;
		}

		let cancelled = false;

		const load = async () => {
			setLoading(true);
			try {
				const { data } = await api.get("/settings");
				const raw = data?.find((s) => s.key === "businessTimezone")?.value;
				const tz =
					raw != null && raw !== false && String(raw).trim() !== ""
						? String(raw).trim()
						: null;
				if (!cancelled) {
					setTimeZone(isValidBusinessTimezone(tz) ? tz : null);
				}
			} catch {
				if (!cancelled) setTimeZone(null);
			} finally {
				if (!cancelled) setLoading(false);
			}
		};

		load();
		return () => {
			cancelled = true;
		};
	}, [isAuth, user?.id, user?.companyId]);

	return (
		<BusinessTimezoneContext.Provider value={{ timeZone, loading }}>
			{children}
		</BusinessTimezoneContext.Provider>
	);
}

function useBusinessTimezone() {
	return useContext(BusinessTimezoneContext);
}

export { BusinessTimezoneProvider, useBusinessTimezone };
